import { useMutation } from "@apollo/client";
import { DeleteContactDocument } from "@/__generated__/graphql";

export const useDeleteContactMutation = () => {
  return useMutation(DeleteContactDocument);
};
